const genSpaceCompactStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [componentCls]: {
      '&-block': {
        display: 'flex',
        width: '100%'
      },
      '&-vertical': {
        flexDirection: 'column'
      }
    }
  };
};
// ============================== Export ==============================
export default genSpaceCompactStyle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/space/style/compact.js
// module id = 3578
// module chunks = 0